/**
 * Som de mensagem nova — o MESMO no ERP e no Cut (2026-11-03): três toques
 * para a pessoa escolher na engrenagem do chat (salvo nas preferências, vale
 * em qualquer aparelho), gerados na hora pelo Web Audio, sem arquivo. O
 * navegador só toca depois que a pessoa mexeu na página; antes, fica calado.
 */
export const SONS = [
  { id: "duplo", nome: "Toque duplo" },
  { id: "gota", nome: "Gota" },
  { id: "sino", nome: "Sino" },
];
export const SOM_PADRAO = "duplo";

// Cada nota: frequência inicial e final (Hz), início e duração (s), volume e forma da onda.
const DESENHOS = {
  duplo: [
    { de: 880, ate: 880, em: 0, dura: 0.12, volume: 0.18, onda: "sine" },
    { de: 1175, ate: 1175, em: 0.13, dura: 0.12, volume: 0.18, onda: "sine" },
  ],
  gota: [{ de: 1400, ate: 620, em: 0, dura: 0.18, volume: 0.22, onda: "sine" }],
  sino: [
    { de: 784, ate: 784, em: 0, dura: 0.5, volume: 0.12, onda: "triangle" },
    { de: 988, ate: 988, em: 0.09, dura: 0.5, volume: 0.12, onda: "triangle" },
    { de: 1319, ate: 1319, em: 0.18, dura: 0.6, volume: 0.12, onda: "triangle" },
  ],
};

let contexto = null;
let somEscolhido = SOM_PADRAO;

/** O som da pessoa (vem das preferências); um id desconhecido volta ao padrão. */
export function escolherSom(id) {
  somEscolhido = DESENHOS[id] ? id : SOM_PADRAO;
}

export function tocarAviso(id = somEscolhido) {
  try {
    const Contexto = window.AudioContext || window.webkitAudioContext;
    if (!Contexto) return;
    contexto = contexto || new Contexto();
    if (contexto.state === "suspended") contexto.resume().catch(() => undefined);
    const agora = contexto.currentTime;
    (DESENHOS[id] || DESENHOS[SOM_PADRAO]).forEach((n) => {
      const osc = contexto.createOscillator();
      const volume = contexto.createGain();
      osc.type = n.onda;
      osc.frequency.setValueAtTime(n.de, agora + n.em);
      if (n.ate !== n.de) osc.frequency.exponentialRampToValueAtTime(n.ate, agora + n.em + n.dura);
      volume.gain.setValueAtTime(0.0001, agora + n.em);
      volume.gain.exponentialRampToValueAtTime(n.volume, agora + n.em + 0.015);
      volume.gain.exponentialRampToValueAtTime(0.0001, agora + n.em + n.dura);
      osc.connect(volume).connect(contexto.destination);
      osc.start(agora + n.em);
      osc.stop(agora + n.em + n.dura + 0.01);
    });
  } catch {
    /* sem áudio no aparelho: o aviso visual continua */
  }
}
